import { Link } from 'react-router-dom';

const services = [
  {
    number: '01',
    icon: 'ri-search-eye-line',
    title: 'Investigation & Analysis',
    description:
      'We analyze your business requirements thoroughly to design the most pragmatic, cost-effective solution before writing a single line of code.',
  },
  {
    number: '02',
    icon: 'ri-code-s-slash-line',
    title: 'Full Cycle Development',
    description:
      'From architecture to deployment – we handle the complete software development lifecycle using proven methodologies and best practices.',
  },
  {
    number: '03',
    icon: 'ri-smartphone-line',
    title: 'Mobile App Development',
    description:
      'Native and cross-platform mobile applications built for iOS and Android that deliver seamless user experiences.',
  },
  {
    number: '04',
    icon: 'ri-cloud-line',
    title: 'Cloud & DevOps',
    description:
      'Cloud infrastructure, CI/CD pipelines, and DevOps practices that ensure your product is scalable, reliable, and maintainable.',
  },
  {
    number: '05',
    icon: 'ri-shake-hands-line',
    title: 'Long-Term Partnership',
    description:
      'We aim to be your technology partner for years – providing continuous support, evolution, and strategic guidance.',
  },
];

export default function ServicesSection() {
  return (
    <section className="bg-[#0C1220] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-2 mb-5">
              <span className="w-6 h-px bg-[#3B82F6]"></span>
              <span className="text-[#3B82F6] text-xs font-semibold uppercase tracking-widest">
                What We Do
              </span>
            </div>
            <h2 className="font-display text-3xl lg:text-4xl font-bold text-white leading-tight text-balance">
              Our Services
            </h2>
          </div>
          <Link
            to="/services"
            className="inline-flex items-center gap-2 text-[#3B82F6] hover:text-white text-sm font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer group"
          >
            View All Services
            <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform duration-200">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#1A2740]">
          {services.map((service) => (
            <div
              key={service.number}
              className="bg-[#0C1220] p-8 hover:bg-[#0F1830] transition-colors duration-200 group"
            >
              <div className="flex items-start justify-between mb-6">
                <span className="text-[#1A2F50] font-display font-bold text-3xl">
                  {service.number}
                </span>
                <span className="w-10 h-10 flex items-center justify-center bg-[#1E3A5F]/40 group-hover:bg-[#3B82F6]/15 rounded-lg transition-colors duration-200">
                  <i className={`${service.icon} text-[#3B82F6] text-xl`}></i>
                </span>
              </div>
              <h3 className="font-semibold text-white text-base mb-3 leading-snug">
                {service.title}
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
